import { render, staticRenderFns } from "./Baogao.vue?vue&type=template&id=0e45f25f&scoped=true"
import script from "./Baogao.vue?vue&type=script&lang=js"
export * from "./Baogao.vue?vue&type=script&lang=js"
import style0 from "./Baogao.vue?vue&type=style&index=0&id=0e45f25f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e45f25f",
  null
  
)

export default component.exports